// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39w9-","colBig":"styles_colBig__yv6ll","colSmall":"styles_colSmall__1tl2P","shopifyNameWrapper":"styles_shopifyNameWrapper__2VUAb"};